module.exports = __webpack_public_path__ + "img/banner-10.91ab966f.jpg";